import { IItem } from "./PopOverMenu";
import "./style/PopOverMenuItem.scss";

export const PopOverMenuItem = ({ icon: Icon, title, onClick, disabled }: IItem) => {
  return (
    <button className="PopOverMenuItem" onClick={onClick} disabled={disabled} aria-label={title}>
      <div className="PopOverMenuItem-Img">
        <Icon />
      </div>
      <span className="PopOverMenuItem-Title">{title}</span>
    </button>
  );
};
